module.exports = __webpack_public_path__ + "static/media/agency-seinfeld-nyc.9cf2dc77.jpg";